var styleDataHash = 'ade97dda';  
export const injectCss = (() => {
  var css = `@charset "UTF-8";.glob_fontElementMap,.yX2Mt{font-family:var(--ricos-font-family,unset)}.JZaOx{box-sizing:border-box;font-family:var(--ricos-settings-text-font-family,Madefor,"Helvetica Neue",Helvetica,Arial,メイリオ,meiryo,"ヒラギノ角ゴ pro w3","hiragino kaku gothic pro",sans-serif);font-size:14px;font-weight:500}[dir] .JZaOx{border-radius:var(--ricos-settings-whitebox-border-radius,2px)}.YVcff{align-items:center;display:flex;height:40px;position:relative}[dir] .YVcff{background-color:#fff;border:1px solid rgba(51,51,51,.1);box-shadow:var(--ricos-settings-whitebox-box-shadow,0 4px 8px 0 rgba(0,0,0,.07));padding:0 4px}._1D69-{height:47px;position:static}[dir] ._1D69-{border-bottom:1px solid rgba(51,51,51,.1);padding:8px 19px}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});

injectCss();



export default {
  "fontElementMap": "yX2Mt",
  "toolbar": "JZaOx",
  "toolbarFloating": "YVcff",
  "toolbarStatic": "_1D69-"
};